import NavLinkPropsWithElement from '../../global/types/NavLinkPropsWithElement'
import Schedule from '../../schedule/components/main/ScheduleMain'
import WorkOrders from '../../work-orders/components/main/WorkOrdersMain'
import QueuesMain from '../../queues/components/main/QueuesMain'
import QualityControlMain from '../../quality-control/main/QualityControlMain'
import { QUALITY_CONTROL_KEYS } from '../constants/quality-control'
import Technicians from '../../technicians/components/main/TechniciansMain'
import PromoCodes from '../../promo-codes/components/main/PromoCodesMain'
import Holidays from '../../holidays/components/main/HolidaysMain'
import Locations from '../../locations/components/main/LocationsMain'
import Reports from '../../reports/components/main/ReportsMain'
import { RequireAuth } from '../components/auth/RequireAuth'
import UserManagement from '../../user-management/main/UserManagementMain'
import ServicesMain from '../../services/main/ServicesMain'
import VansMain from '../../vans/main/VansMain'
import DashboardsMain from '../../dashboards/main/DashboardsMain'
import SmallPartSuppliesMain from '../../small-part-supplies/components/main/SmallPartSuppliesMain'
import { TITLES } from '../constants/nav-bar-links'
import { PERMISSIONS } from '../constants/permissions'
import { Route } from 'react-router-dom'
import ModalContent from '../../work-orders/components/work-order-detail/components/main/ModalContent'
import BiReportsMain from '../../bi-reports/components/main/BiReportsMain'
import TrSalesMain from '../../tr-sales-appointment-booking/main/TrSalesMain'
import { DASHBOARD_KEYS, DASHBOARD_PATHS } from '../constants/dashboards'
import AuditsMain from '../../audits/main/AuditsMain'
import { AUDIT_KEYS } from '../constants/audit'
import TechnicianScorecardMain from '../../technician-scorecard/main/TechnicianScorecardMain'
import IncidentReportsMain from '../../incident-reports/main/IncidentReportsMain'
import TechnicianAssistantMain from '../../technician-assistant/main/TechnicianAssistantMain'
import { TECH_ASSISTANT_KEYS, TECH_ASSISTANT_PATHS } from '../constants/technician-assistant'

const linksData: Array<NavLinkPropsWithElement> = [
  {
    to: '/',
    title: TITLES.SCHEDULE,
    permissionInfo: {
      category: PERMISSIONS.NAV_BAR.CATEGORY,
      name: PERMISSIONS.NAV_BAR.ENTRIES.VIEW_SCHEDULE.NAME,
    },
    element: (
      <RequireAuth>
        <Schedule />
      </RequireAuth>
    ),
    nestedRoutes: [
      <Route
        path=':id'
        element={<ModalContent />}
      />,
    ],
  },
  {
    to: '/work-orders',
    title: TITLES.WORK_ORDERS,
    permissionInfo: {
      category: PERMISSIONS.NAV_BAR.CATEGORY,
      name: PERMISSIONS.NAV_BAR.ENTRIES.VIEW_WORK_ORDERS.NAME,
    },
    element: (
      <RequireAuth>
        <WorkOrders />
      </RequireAuth>
    ),
    nestedRoutes: [
      <Route
        path=':id'
        element={<ModalContent />}
      />,
    ],
  },
  {
    to: '/queues',
    title: TITLES.QUEUES,
    permissionInfo: {
      category: PERMISSIONS.NAV_BAR.CATEGORY,
      name: PERMISSIONS.NAV_BAR.ENTRIES.VIEW_QUEUES.NAME,
    },
    element: (
      <RequireAuth>
        <QueuesMain />
      </RequireAuth>
    ),
  },
  {
    to: '/quality-control/cases',
    title: TITLES.QUALITY_CONTROL,
    permissionInfo: {
      category: PERMISSIONS.NAV_BAR.CATEGORY,
      name: PERMISSIONS.NAV_BAR.ENTRIES.VIEW_CASES.NAME,
    },
    element: (
      <RequireAuth>
        <QualityControlMain tabType={QUALITY_CONTROL_KEYS.casesTable} />
      </RequireAuth>
    ),
  },
  {
    to: '/incident-reports',
    title: TITLES.INCIDENT_REPORTS,
    permissionInfo: {
      category: PERMISSIONS.NAV_BAR.CATEGORY,
      name: PERMISSIONS.NAV_BAR.ENTRIES.VIEW_INCIDENT_REPORTS.NAME,
    },
    element: (
      <RequireAuth>
        <IncidentReportsMain />
      </RequireAuth>
    ),
  },
  {
    to: '/technicians',
    title: TITLES.TECHNICIANS,
    permissionInfo: {
      category: PERMISSIONS.NAV_BAR.CATEGORY,
      name: PERMISSIONS.NAV_BAR.ENTRIES.VIEW_TECHNICIANS.NAME,
    },
    element: (
      <RequireAuth>
        <Technicians />
      </RequireAuth>
    ),
  },
  {
    to: '/technician-scorecards',
    title: TITLES.TECHNICIAN_SCORECARD,
    permissionInfo: {
      category: PERMISSIONS.NAV_BAR.CATEGORY,
      name: PERMISSIONS.NAV_BAR.ENTRIES.VIEW_TECHNICIAN_SCORECARDS.NAME,
    },
    element: (
      <RequireAuth>
        <TechnicianScorecardMain />
      </RequireAuth>
    ),
  },
  {
    to: TECH_ASSISTANT_PATHS.aiAssistant,
    title: TITLES.TECHNICIAN_ASSISTANT,
    permissionInfo: {
      category: PERMISSIONS.NAV_BAR.CATEGORY,
      name: PERMISSIONS.NAV_BAR.ENTRIES.VIEW_TECHNICIAN_ASSISTANT.NAME,
    },
    element: (
      <RequireAuth>
        <TechnicianAssistantMain tabType={TECH_ASSISTANT_KEYS.aiAssistant} />
      </RequireAuth>
    ),
  },
  {
    to: '/promo-codes',
    title: TITLES.PROMO_CODES,
    permissionInfo: {
      category: PERMISSIONS.NAV_BAR.CATEGORY,
      name: PERMISSIONS.NAV_BAR.ENTRIES.VIEW_PROMO_CODES.NAME,
    },
    element: (
      <RequireAuth>
        <PromoCodes />
      </RequireAuth>
    ),
  },
  {
    to: '/holidays',
    title: TITLES.HOLIDAYS,
    permissionInfo: {
      category: PERMISSIONS.NAV_BAR.CATEGORY,
      name: PERMISSIONS.NAV_BAR.ENTRIES.VIEW_HOLIDAYS.NAME,
    },
    element: (
      <RequireAuth>
        <Holidays />
      </RequireAuth>
    ),
  },
  {
    to: '/vans',
    title: TITLES.VANS,
    permissionInfo: {
      category: PERMISSIONS.NAV_BAR.CATEGORY,
      name: PERMISSIONS.NAV_BAR.ENTRIES.VIEW_VANS.NAME,
    },

    element: (
      <RequireAuth>
        <VansMain />
      </RequireAuth>
    ),
    nestedRoutes: [
      <Route
        path=':id'
        element={
          <RequireAuth>
            <VansMain />
          </RequireAuth>
        }
      />,
    ],
  },
  {
    to: '/small-part-supplies',
    title: TITLES.SMALL_PART_INVENTORY,
    permissionInfo: {
      category: PERMISSIONS.NAV_BAR.CATEGORY,
      name: PERMISSIONS.NAV_BAR.ENTRIES.VIEW_SMALL_PART_INVENTORY.NAME,
    },
    element: (
      <RequireAuth>
        <SmallPartSuppliesMain />
      </RequireAuth>
    ),
  },
  {
    to: '/locations',
    title: TITLES.LOCATIONS,
    permissionInfo: {
      category: PERMISSIONS.NAV_BAR.CATEGORY,
      name: PERMISSIONS.NAV_BAR.ENTRIES.VIEW_LOCATIONS.NAME,
    },
    element: (
      <RequireAuth>
        <Locations />
      </RequireAuth>
    ),
  },
  {
    to: '/services',
    title: TITLES.SERVICES,
    permissionInfo: {
      category: PERMISSIONS.NAV_BAR.CATEGORY,
      name: PERMISSIONS.NAV_BAR.ENTRIES.VIEW_SERVICES.NAME,
    },
    element: (
      <RequireAuth>
        <ServicesMain />
      </RequireAuth>
    ),
  },
  {
    to: '/tr-sales',
    title: TITLES.TR_SALES,
    permissionInfo: {
      category: PERMISSIONS.NAV_BAR.CATEGORY,
      name: PERMISSIONS.NAV_BAR.ENTRIES.VIEW_TR_SALES.NAME,
    },
    element: (
      <RequireAuth>
        <TrSalesMain />
      </RequireAuth>
    ),
  },
  {
    to: '/reports',
    title: TITLES.CS_REPORTS,
    permissionInfo: {
      category: PERMISSIONS.NAV_BAR.CATEGORY,
      name: PERMISSIONS.NAV_BAR.ENTRIES.VIEW_REPORTS.NAME,
    },
    element: (
      <RequireAuth>
        <Reports />
      </RequireAuth>
    ),
    nestedRoutes: [
      <Route
        path='work-order/:id'
        element={<ModalContent />}
      />,
      <Route
        path='tire-delivery/:id'
        element={<ModalContent />}
      />,
    ],
  },
  {
    to: '/audits/dvir',
    title: TITLES.AUDITS,
    permissionInfo: {
      category: PERMISSIONS.NAV_BAR.CATEGORY,
      name: PERMISSIONS.NAV_BAR.ENTRIES.VIEW_AUDITS.NAME,
    },
    element: (
      <RequireAuth>
        <AuditsMain tabType={AUDIT_KEYS.dvir} />
      </RequireAuth>
    ),
  },
  {
    to: DASHBOARD_PATHS.futurePercentBooked,
    title: TITLES.DASHBOARDS,
    permissionInfo: {
      category: PERMISSIONS.NAV_BAR.CATEGORY,
      name: PERMISSIONS.NAV_BAR.ENTRIES.VIEW_DASHBOARDS.NAME,
    },
    element: (
      <RequireAuth>
        <DashboardsMain tabType={DASHBOARD_KEYS.futurePercentBooked} />
      </RequireAuth>
    ),
    nestedRoutes: [
      <Route
        path=':id'
        element={<ModalContent />}
      />,
    ],
  },
  {
    to: '/bi-reports',
    title: TITLES.BI_REPORTS,
    permissionInfo: {
      category: PERMISSIONS.NAV_BAR.CATEGORY,
      name: PERMISSIONS.NAV_BAR.ENTRIES.VIEW_BI_REPORT_UPLOADS.NAME,
    },
    element: (
      <RequireAuth>
        <BiReportsMain />
      </RequireAuth>
    ),
  },
  {
    to: '/user-management/users',
    title: TITLES.USER_MANAGEMENT,
    permissionInfo: {
      category: PERMISSIONS.NAV_BAR.CATEGORY,
      name: PERMISSIONS.NAV_BAR.ENTRIES.VIEW_USER_MANAGEMENT.NAME,
    },
    element: (
      <RequireAuth>
        <UserManagement tabType='users' />
      </RequireAuth>
    ),
    nestedRoutes: [
      <Route
        path=':id'
        element={<ModalContent />}
      />,
    ],
  },
]

export default linksData
